module.exports = __webpack_public_path__ + "img/vincent_n.082f70de.png";